module.exports = __webpack_public_path__ + "img/21_78.988b7dc5.png";